import Slideshow from '../../../components/slideshow/Slideshow';
import Constants from '../../../utils/Constants';

const Gallery = ({ imageList }: { imageList: string[] }) => {
  return (
    <div id={Constants.GALLERY} className='gallery'>
      <div className='gallery_container container'>
        <h2>GALERIJA</h2>
        <div className='gallery_container_imgs'>
          <Slideshow slideshowImages={imageList} />
        </div>
      </div>
    </div>
  );
};

export default Gallery;
